import React, { useCallback, useState } from "react";
import Layout from "@/components/Layout/Layout";
import { withAdmin } from "@/services/withAdmin";
import { IAdminFireBase } from "@/store/models/admin.models";
import useItemsPerPage from "@/hooks/useItemsPerPage";
import styles from "./VideoContent.module.scss";
import videoIcon from "@/assets/icons/video.svg";
import { Button, Pagination } from "@mui/material";
import { VideoCard } from "@/components/VideoCard/VideoCard";
import { IMedia } from "@/store/models/video.models";
import DeleteModal from "@/components/DeleteModal/DeleteModal";
import { AddFeaturedItem } from "../AddFeaturedItem/AddFeaturedItem";
import {
  useDeleteMediaMutation,
  useGetRecommendedMediaQuery,
} from "@/store/rtk-api/media.api";

const VideoContentCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  const [page, setPage] = useState(1);
  const [isOpenDeleteVideoModal, setIsOpenDeleteVideoModal] = useState(false);
  const [isOpenAddVideo, setIsOpenAddVideo] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<IMedia | null>(null);
  const itemsPerPage = useItemsPerPage(2, 2, 3, 1280, 1680);

  const { data: videoData } = useGetRecommendedMediaQuery({
    mediaType: "video",
  });

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  const handleToggleModal = () => {
    setIsOpenAddVideo((prev) => !prev);
  };

  const [deleteVideoByUid] = useDeleteMediaMutation();

  const handleToggleDeleteVideoModal = (video: IMedia) => {
    setSelectedVideo(video);
    setIsOpenDeleteVideoModal(true);
  };

  const handleDeleteVideo = useCallback(async () => {
    if (selectedVideo) {
      await deleteVideoByUid(selectedVideo.uid);
      setIsOpenDeleteVideoModal(false);
    }
  }, [deleteVideoByUid, selectedVideo]);

  const videoDataFiltered = videoData?.filter((video) =>
    video.sections.includes("Recommendation")
  );

  return (
    <Layout admin={admin}>
      <div className={styles.container}>
        <div className={styles.topSection}>
          <div className={styles.topSectionTitle}>
            <p>Video</p>
            <img src={videoIcon} alt="video" />
          </div>
          <Button
            sx={{
              textTransform: "capitalize",
              height: "44px",
              width: "174px",
              backgroundColor: "#008000",
              borderRadius: "12px",

              "&:hover": {
                backgroundColor: "#008000",
              },
            }}
            variant="contained"
            onClick={handleToggleModal}
          >
            Add item
          </Button>
        </div>
        <div className={styles.itemsContainer}>
          {videoDataFiltered && videoDataFiltered.length > 0 ? (
            videoDataFiltered
              .filter(
                (video, index, self) =>
                  index === self.findIndex((v) => v.uid === video.uid)
              )
              .map((video) => (
                <VideoCard
                  key={video.uid}
                  video={video}
                  handleToggleDeleteModal={handleToggleDeleteVideoModal}
                  isEdit={false}
                  isFeatured
                />
              ))
          ) : (
            <p style={{ marginLeft: "20px" }}>No data yet</p>
          )}
        </div>

        {isOpenDeleteVideoModal && (
          <DeleteModal
            isOpen={isOpenDeleteVideoModal}
            setIsOpen={setIsOpenDeleteVideoModal}
            name={selectedVideo ? selectedVideo.title : ""}
            supportingText="Are you sure you want to delete this video?"
            onDelete={handleDeleteVideo}
          />
        )}

        {isOpenAddVideo && (
          <AddFeaturedItem
            isOpen={isOpenAddVideo}
            setIsOpen={setIsOpenAddVideo}
            type="video"
          />
        )}

        {videoDataFiltered && videoDataFiltered.length > 0 && (
          <Pagination
            page={page}
            onChange={handlePageChange}
            count={Math.ceil(videoDataFiltered.length / itemsPerPage)}
          />
        )}
      </div>
    </Layout>
  );
};

export const VideoContent = withAdmin(VideoContentCmp);
VideoContentCmp.displayName = "VideoContentCmp";

